function forceCssReflow(element) {
    // Reading an element's offset height forces its CSS to reflow.
    return element.offsetHeight;
}

export default forceCssReflow;
